module.exports = __webpack_public_path__ + "media/images/lp_v6_step04-ea93252fd374a0333cc258e23d66a787.webp";